import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { DSCardBody } from './DSCardBody.js';
import { DSCardHeader } from './DSCardHeader.js';

var DSCard = function DSCard(_ref) {
  var _ref$innerRef = _ref.innerRef,
      innerRef = _ref$innerRef === void 0 ? undefined : _ref$innerRef,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      otherProps = _objectWithoutProperties(_ref, ["innerRef", "children", "containerProps"]);

  var _convertPropToCssClas = convertPropToCssClassName('card'),
      cssClassName = _convertPropToCssClas.cssClassName;

  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "card"
  }, containerProps, {
    ref: innerRef,
    className: cssClassName
  }, otherProps), children);
};

var cardProps = {
  /** inject props to component wrapper */
  containerProps: PropTypes.object.description('inject props to component wrapper'),

  /**
   * Get reference for the button
   */
  innerRef: PropTypes.string.description('Get reference for the button'),

  /**
   * DSCardBody and DSCardHeader
   */
  children: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf([DSCardHeader, DSCardBody])
  })).description('DSCardBody and DSCardHeader')
};
DSCard.propTypes = cardProps;
var DSCardWithSchema = describe(DSCard);
DSCardWithSchema.propTypes = cardProps;

export default DSCard;
export { DSCard, DSCardWithSchema };
//# sourceMappingURL=DSCard.js.map
